import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";
import { RtoSettingsSection } from "@/components/ops/RtoSettingsSection";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";

/**
 * Host component for the `rtoTerms` mode in the Ops bucket. Re-homed
 * out of Tenant Admin → Org Administration → "RTO Settings" accordion
 * on 2026-06-15 per docs/design/admin_split_and_entitlements.md §7.7.
 *
 * The underlying `RtoSettingsSection` (with its term-row editor,
 * state-overrides editor, and manufacturer-inherited-terms switch)
 * moved unchanged from `src/components/admin/` to
 * `src/components/ops/`; only the entry point + role gate changed.
 */
export function OpsRtoTermsPanel() {
  const organizationId = useScopedOrganizationId();

  if (!organizationId) {
    return (
      <div className="w-full text-left space-y-3">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">RTO Terms</h2>
        <p className="text-sm text-gray-500 dark:text-zinc-400">
          Select a workspace organization first.
        </p>
      </div>
    );
  }

  return (
    <div {...{ [FIREFLY_TARGET_ATTR]: "rto-terms-surface" }} className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">RTO Terms</h2>
      </div>
      <p className="text-sm text-gray-600 dark:text-zinc-300">
        Rent-to-own term definitions Sales Console pulls into its RTO calculator. Set the
        provider display name, define term rows (divisor + required down), and add
        state-specific overrides. Manufacturers can be inherited via the
        "Use manufacturer RTO terms" switch below.
      </p>
      <RtoSettingsSection organizationId={organizationId} />
    </div>
  );
}
